import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Input, notification } from "antd";
import { saveAgentKnowledgeSettings } from "util/agentKnowledgeApi";
import { knowledgeErrorText } from "./knowledgeErrors";
import styles from "./style.module.scss";

const DISCLOSURE_MAX = 600;

// The disclosure every voice survey of the company reads out unless it has its own.
const DisclosureTab = ({ data, onChanged }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(data.disclosure || "");
  const [saving, setSaving] = useState(false);
  const canEdit = data.can_manage && !data.read_only;

  useEffect(() => setValue(data.disclosure || ""), [data.disclosure]);

  const save = async () => {
    setSaving(true);
    const res = await saveAgentKnowledgeSettings(value);
    setSaving(false);
    if (!res || res.error) {
      notification.error({ message: knowledgeErrorText(t, res), placement: "bottomRight" });
      return;
    }
    notification.success({ message: t("surveySettings.disclosure.saved"), placement: "bottomRight" });
    onChanged();
  };

  return (
    <Card size="small" className={styles.disclosureCard}>
      <p className={styles.intro}>{t("surveySettings.disclosure.intro")}</p>
      <div className={styles.modalField}>
        <Input.TextArea
          rows={3}
          maxLength={DISCLOSURE_MAX}
          showCount
          value={value}
          disabled={!canEdit}
          placeholder={t("surveySettings.disclosure.placeholder")}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      {canEdit ? (
        <Button type="primary" loading={saving} disabled={value === (data.disclosure || "")} onClick={save}>
          {t("surveySettings.knowledge.save")}
        </Button>
      ) : null}
    </Card>
  );
};

export default DisclosureTab;
